import { render, staticRenderFns } from "./app-header.html?vue&type=template&id=34dfdeb5&scoped=true&external"
import script from "./app-header.js?vue&type=script&lang=js&external"
export * from "./app-header.js?vue&type=script&lang=js&external"
import style0 from "./app-header.scss?vue&type=style&index=0&id=34dfdeb5&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dfdeb5",
  null
  
)

export default component.exports